import {
  Typography,
  Card,
  CardHeader,
  Divider,
  TableRow,
  TableCell,
  Table,
  TableBody,
} from "@mui/material";
import React from "react";

export default function MeasurementDetail({ props, wall, noteTest, formData }) {
  return (
    <>
      <Card elevation={0} style={{ marginBottom: "30px" }}>
        {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
        <CardHeader title="Basic informations" />
        <Divider />

        <Table sx={{ minWidth: 700 }}>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Direction of emission
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography>{formData.directionOfEmission}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Type of noise
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography>
                  <Typography>{formData.typeOfNoise}</Typography>
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Spectrum of measurements
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography>
                  <Typography>{formData.spectrumOfMeasurements}</Typography>
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>
      <Card elevation={0} style={{ marginBottom: "30px" }}>
        {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
        <CardHeader
          title={`Basic spectre (${formData.spectrumOfMeasurements})`}
        />
        <Divider />

        <Table sx={{ minWidth: 700 }}>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  DnTw 100 3150Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography>
                  {formData.DnTw_100_3150Hz ? (
                    <Typography>
                      {formData.DnTw_100_3150Hz}
                      <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                        {" "}
                        dB{" "}
                      </span>
                    </Typography>
                  ) : (
                    ""
                  )}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  C 100 3150Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography>
                  {formData.C_100_3150Hz ? (
                    <Typography>
                      {formData.C_100_3150Hz}
                      <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                        {" "}
                        dB{" "}
                      </span>
                    </Typography>
                  ) : (
                    ""
                  )}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  CTR 100 3150Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography>
                  {formData.CTR_100_3150Hz ? (
                    <Typography>
                      {formData.CTR_100_3150Hz}
                      <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                        {" "}
                        dB{" "}
                      </span>
                    </Typography>
                  ) : (
                    ""
                  )}
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>
      <Card elevation={0} style={{ marginBottom: "30px" }}>
        {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
        <CardHeader
          title={`Complete spectre (${formData.spectrumOfMeasurements})`}
        />
        <Divider />

        <Table sx={{ minWidth: 700 }}>
          <TableBody>
            {/* <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  50 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_50Hz ? (
                  <Typography>
                    {formData.cs_50Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  63 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_63Hz ? (
                  <Typography>
                    {formData.cs_63Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  80 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_80Hz ? (
                  <Typography>
                    {formData.cs_80Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow> */}
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  100 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_100Hz ? (
                  <Typography>
                    {formData.cs_100Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  125 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_125Hz ? (
                  <Typography>
                    {formData.cs_125Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  160 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_160Hz ? (
                  <Typography>
                    {formData.cs_160Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  200 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_200Hz ? (
                  <Typography>
                    {formData.cs_200Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  250 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_250Hz ? (
                  <Typography>
                    {formData.cs_250Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  315 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_315Hz ? (
                  <Typography>
                    {formData.cs_315Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  400 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_400Hz ? (
                  <Typography>
                    {formData.cs_400Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  500 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_500Hz ? (
                  <Typography>
                    {formData.cs_500Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  630 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_630Hz ? (
                  <Typography>
                    {formData.cs_630Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  800 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_800Hz ? (
                  <Typography>
                    {formData.cs_800Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  1000 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_1000Hz ? (
                  <Typography>
                    {formData.cs_1000Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  1250 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_1250Hz ? (
                  <Typography>
                    {formData.cs_1250Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  1600 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_1600Hz ? (
                  <Typography>
                    {formData.cs_1600Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  2000 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_2000Hz ? (
                  <Typography>
                    {formData.cs_2000Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  2500 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_2500Hz ? (
                  <Typography>
                    {formData.cs_2500Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  3150 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_3150Hz ? (
                  <Typography>
                    {formData.cs_3150Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            {/* <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  4000 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_4000Hz ? (
                  <Typography>
                    {formData.cs_4000Hz}
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  5000 Hz
                </Typography>
              </TableCell>
              <TableCell align="right">
                {formData.cs_5000Hz ? (
                  <Typography>
                    formData.cs_5000Hz
                    <span style={{ color: "#1f68b2", fontSize: "14px" }}>
                      {" "}
                      dB{" "}
                    </span>
                  </Typography>
                ) : (
                  ""
                )}
              </TableCell>
            </TableRow> */}
          </TableBody>
        </Table>
      </Card>
    </>
  );
}
